import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=bdf3606e"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=bdf3606e&prod&lang=sass"
import style1 from "./Table.vue?vue&type=style&index=1&id=bdf3606e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports